export default function PHP_callable() {
  return (
    <div>
      <h1>PHP_callable</h1>
    </div>
  );
}
